<span class="status-label" [class]="statusClass">
  @switch (status) {
    @case (3) {
      <a [routerLink]="['/quotes', quote.quote_id]" class="btn-buy">
        {{ perms.orderCreate ? 'BUY NOW' : 'Review' }}
      </a>
    }
    @case (4) {
      Ordered
      @if (quote.so_tranno) {
        - <a [routerLink]="['/orders', quote.so_tranno]">{{ quote.so_tranno }}</a>
      }
    }
    @default {
      {{ statusLabel }}
    }
  }
</span>
